const steps = [
  {
    number: "01",
    title: "Initial Consultation",
    desc: "We review your situation, understand the legal issues, and explain how our 40 years of experience can help navigate your matter effectively.",
    icon: "ri-discuss-line",
  },
  {
    number: "02",
    title: "Case Evaluation",
    desc: "Thorough analysis of the facts, applicable regulations, and legal landscape to assess the strength and scope of your case.",
    icon: "ri-search-eye-line",
  },
  {
    number: "03",
    title: "Strategy Development",
    desc: "We craft a tailored legal strategy designed to achieve your goals while managing risk and minimizing disruption to your operations.",
    icon: "ri-road-map-line",
  },
  {
    number: "04",
    title: "Legal Representation",
    desc: "We advocate on your behalf in negotiations, administrative proceedings, or litigation with precision and full commitment.",
    icon: "ri-scales-3-line",
  },
  {
    number: "05",
    title: "Resolution & Follow-Up",
    desc: "We work toward a favorable resolution and provide ongoing guidance to help implement outcomes and prevent future exposure.",
    icon: "ri-checkbox-circle-line",
  },
];

export default function SectionProcess() {
  return (
    <section className="bg-[#0A1628] py-24 relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full"
          style={{
            backgroundImage: "repeating-linear-gradient(45deg, #C9A961 0, #C9A961 1px, transparent 0, transparent 50%)",
            backgroundSize: "30px 30px",
          }}
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="block text-[11px] tracking-[0.25em] text-[#C9A961] uppercase font-inter font-medium mb-3">
            How We Work
          </span>
          <h2 className="text-4xl lg:text-5xl font-playfair font-bold text-white mb-4">
            Our Legal Process
          </h2>
          <p className="text-slate-400 font-inter text-base max-w-xl mx-auto">
            From first contact to final resolution, we guide you through every step with clarity and expertise.
          </p>
        </div>

        {/* Desktop */}
        <div className="hidden lg:grid grid-cols-5 gap-4 relative">
          {/* Connecting line */}
          <div className="absolute top-12 left-[10%] right-[10%] h-px">
            <div className="w-full h-full bg-gradient-to-r from-transparent via-[#C9A961]/40 to-transparent" />
          </div>

          {steps.map((step, i) => (
            <div key={i} className="flex flex-col items-center text-center relative pt-2">
              <div className="w-24 h-24 rounded-full border-2 border-[#C9A961]/60 bg-[#0A1628] flex flex-col items-center justify-center mb-6 relative z-10 hover:border-[#C9A961] transition-colors duration-300 group cursor-default">
                <span className="text-[10px] tracking-widest text-[#C9A961]/60 font-inter font-medium group-hover:text-[#C9A961] transition-colors">
                  {step.number}
                </span>
                <span className="w-7 h-7 flex items-center justify-center mt-1">
                  <i className={`${step.icon} text-[#C9A961] text-xl`} />
                </span>
              </div>
              <h3 className="text-sm font-playfair font-semibold text-white mb-2 leading-snug">
                {step.title}
              </h3>
              <p className="text-slate-400 text-xs font-inter leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        {/* Mobile */}
        <div className="lg:hidden flex flex-col gap-0 relative">
          <div className="absolute left-6 top-6 bottom-6 w-px bg-gradient-to-b from-[#C9A961]/60 via-[#C9A961]/30 to-transparent" />
          {steps.map((step, i) => (
            <div key={i} className="flex gap-6 pl-2 pb-8 last:pb-0">
              <div className="w-12 h-12 rounded-full border-2 border-[#C9A961]/60 bg-[#0A1628] flex flex-col items-center justify-center flex-shrink-0 relative z-10">
                <span className="text-[9px] text-[#C9A961]/60 font-inter font-bold">{step.number}</span>
                <i className={`${step.icon} text-[#C9A961] text-sm mt-0.5`} />
              </div>
              <div className="pt-2">
                <h3 className="text-base font-playfair font-semibold text-white mb-1.5">
                  {step.title}
                </h3>
                <p className="text-slate-400 text-sm font-inter leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
